<template>
  <Row>
    <Col span="18" class="mt-1">
      <Row v-if="tb1.length">
        <table
          v-for="(it , index) in tb1arry"
          :key="index+'tt'"
          class="left TB_COLLAPSE"
          :class="[cloce]"
          width="16.6%"
        >
          <thead>
            <th width="30%">{{getliveshow.title}}</th>
            <th width="70%">賠率占成</th>
          </thead>
          <tbody>
            <tr
              v-for="(item, key) in it"
              :key="key+'tc'"
              class="tc"
              :class="[checkRankingColor(item.name)]"
            >
              <th :class="[classColor(item.colour)]">
                <span v-if="showStar(item)">*</span>
                <span v-if="item.odddtl == 1" style="cursor: pointer" @click="e => checkBoxChange(e, item)">{{ item.name }}</span>
                <span v-else>{{ item.name }}</span>
              </th>
              <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
                <table-adjust-odds :table="item" @go_live_show_bridge="go_live_show_bridge"></table-adjust-odds>
              </td>
            </tr>
          </tbody>
        </table>
      </Row>
      <!-- <Row v-if="tb3.length">
        <template v-if="this.$route.meta.page == 1">
          <table class="left TB_COLLAPSE" width="99.5%" :class="[cloce]">
            <thead>
              <template v-for="item in 6">
                <th width="5%">
                  {{$route.meta.title}}
                  <br />生肖
                </th>
                <th width="11.5%">賠率占成</th>
              </template>
            </thead>
            <tbody v-for="(it , index) in tb3arry" :key="index">
              <tr>
                <template v-for="(item, key) in it">
                  <th :key="item.name">
                    <h3>{{ item.name }}</h3>
                  </th>
                  <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
                    <table-adjust-odds
                      :key="item.troddid"
                      :table="item"
                      @go_live_show_bridge="go_live_show_bridge"
                    ></table-adjust-odds>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <div class="right mr-1" v-if="this.liveshowPath">
            <span>补货限额：</span>
            <Input
              search
              enter-button="修改"
              v-model="input"
              placeholder="修改特码补货设定"
              style="width:200px;display: inline-table;"
              @on-enter="modifyCheck"
              @on-search="modifyCheck"
            />
          </div>
        </template>
      </Row> -->
    </Col>
    <Col span="6" class="rigth-table">
      <table-right-ranking ref="tableRightRanking"></table-right-ranking>
    </Col>
  </Row>
</template>

<script>
import { Utile } from 'utils'
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import checkpath from './mixins/checkPath.js'
import liveshowSixmark from '@/mixins/liveshow-sixmark.js'
import TableRightRanking from './components/TableRightRanking'
export default {
  name: 'livshow-scode',
  mixins: [checkpath, liveshowSixmark],
  components: {
    TableRightRanking
  },
  data () {
    return {
      tb1: [],
      tb3: [],
      tb1arry: [],
      input: null,
      modifyCheckStatus: false,
      checkBoxValue: [],
    };
  },
  computed: {
    ...mapGetters(["getliveshow", "getmember", "getgameid"]),
    tb3arry () {
      return Utile.chunk(this.tb3, 6);
    },
    KeyName () {
      return this.liveshowPath ? 'supodod' : 'linksupodod'
    },
    sortItems () {
      if (this.$route.meta.page != 1) return []
      return this.tb1.slice().sort((a, b) => b.ltl - a.ltl).slice(0, 5).map(it => it.name)
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.routerSplit(to.name) != this.routerSplit(from.name)) {
        this.tb3 = []
        this.tb1 = []
      }
      if (to.meta.page != 1) this.tb3 = []
      // this.readyaxiso();
      this.input = this.getliveshow.topbardata.pm1limit
      this.chg_liveshow_state({ title: this.$route.meta.title });
      this.upTargetData(false)
      if (this.$route.meta.page == 1) this.getMarkList()
    },
    'getliveshow.chgbaco' (val) {
      this.chgbacofun();
    },
    'getliveshow.tema' (val) {
      this.chgbacofun();
    },
    'getliveshow.topbardata' (val) {
      if (!this.modifyCheckStatus && this.input == null) this.input = val.pm1limit
    },
    'getliveshow.targetData' (val) {
      this.checkBoxValue = Array.from({length:49}, v => false)
      val.forEach(num => {
        this.checkBoxValue[num-1] = true
      })
    }
  },
  created () {
    this.chgbacofun();
  },
  mounted () {
    this.chg_liveshow_state({ title: this.$route.meta.title });
    if (this.$route.meta.page == 1) this.getMarkList()
  },
  methods: {
    ...mapActions(['chg_liveshow_state', 'setPm1limit']),
    ...mapMutations(['upTargetModeValue', 'upTargetData', 'deleteTargetData']),
    checkRankingColor (val) {
      if (!this.sortItems.length || this.getBettingStatus == 0) return
      const state = this.sortItems.some(it => it == val)
      return { 'ranking-top': state }
    },
    //正码_重组阵列公式
    textarray (arr) {
      const lastArray = this.$route.meta.page == 2 ? 54 : 58
      const cut = [[0, 10], [10, 20], [20, 30], [30, 40], [40, 49], [49, lastArray]]
      return cut.map((it, i) => arr.slice(...it));
    },
    chgbacofun () {
      const chgbaco = this.getliveshow.chgbaco
      this.get_tb1(chgbaco);
      // this.get_tb3(chgbaco);
    },
    //get_tb1() 先预设 scode_1_api 再去判断 盘口 切换时 更换api
    async get_tb1 (baco) {
      const meta = this.$route.meta
      try {
        const obj = {
          gameid: this.getgameid,
          page: meta.page,
          odd: meta.page == 1 ? meta.odd[this.getliveshow.tema] : meta.odd,
          baco: baco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.tb1 = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        if ('status' in res && res.status === 0) return
        this.IsstopColor(res)
        if (res.length) {
          this.tb1 = res.map(it => (it.clas = 0, it));
          if (this.$refs.tableRightRanking) {
            this.$refs.tableRightRanking.firstaxios(this.tb1.slice(0, 49))
          }
          this.settb1arry()
        }
      } catch (error) {
        console.error(error);
        this.$Message.error(`网路异常：(S310${meta.page}`);
      }
    },
    settb1arry () {
      if (this.$route.meta.page == '1') {
        const findNameData = (nameData) => {
          return nameData.reduce((arry, name) => {
            let findData = this.tb1.find(item => item.name.includes(name))
            arry.push(findData)
            return arry
          }, [])
        }
        const numberAry = this.tb1.filter(item => [1, 86].includes(item.odddtl))
        const colorData = findNameData(['紅', '藍', '綠'])
        const twoSideData = findNameData(['特单', '特双', '特大', '特小', '合单', '合双', '合大', '合小', '尾大', '尾小', '家禽', '野兽'])
        const twoSideData2 = findNameData(['总单', '总双', '总大', '总小'])
        let tbarry = Utile.chunk(numberAry, 10)
        for (let index = 0; index < 4; index++) {
          tbarry[index] = [...tbarry[index], twoSideData2[index]]
        }
        tbarry[4] = [...tbarry[4], ...colorData]
        tbarry[5] = twoSideData
        this.tb1arry = tbarry
      } else {
        const numberAry = this.tb1.filter(item => item.odddtl == Number(this.$route.meta.page))
        const pscode = Number(this.$route.meta.page) - 2
        const twoSideOddlt = [`${pscode}单`, `${pscode}双`, `${pscode}大`, `${pscode}小`, `${pscode}合单`, `${pscode}合双`, `${pscode}合大`, `${pscode}合小`, `${pscode}紅`, `${pscode}藍`, `${pscode}綠`]
        const twoSideData = twoSideOddlt.reduce((arry, name) => {
            arry.push(this.tb1.find(item => item.name.includes(name)))
            return arry
        }, [])
        let tbarry = Utile.chunk(numberAry, 10)
        if (this.$route.meta.page !== '2') tbarry[5] = twoSideData
        this.tb1arry = tbarry
      }
    },
    async get_tb3 (baco) {
      if (this.$route.meta.page == 1) {
        const meta = this.$route.meta
        try {
          const obj = {
            gameid: this.getgameid,
            page: '16',
            odd: '13',
            baco: baco,
            site: this.getliveshow.siteSelect
          }
          if (this.getliveshow.siteSelect == '') {
          this.tb3 = []
          return
        }
          const res = await this.$axios.liveshow[this.KeyName](obj);
          this.IsstopColor(res)
          this.tb3 = res.map(it => (it.clas = 0, it));
        } catch (error) {
          console.error(error);
          this.$Message.error(`网路异常：(S320${meta.page}`);
        }
      }
    },
    modifyCheck () {
      this.modifyCheckStatus = true
      this.$Modal.confirm({
        title: `是否修改特码补货限额為:${this.$commaFormat(this.input)}`,
        onOk: () => this.modify(),
        onCancel: () => this.modifyCheckStatus = false,
        cancelText: '取消'
      });
    },
    modify () {
      const obj = {
        loid: this.getmember.pid,
        reppid: '1',
        items: [{ id: 1, newvalue: this.input }]
      }
      this.$axios.setting.modifyReplenishmentList(this.getgameid, obj)
        .then(res => {
          if (res.status == 1) {
            this.$Notice.success({ title: "补货限额修改成功" });
            this.setPm1limit(this.input)
          }
          this.modifyCheckStatus = false
        }).catch(error => {
          console.error(error)
          this.$Notice.error("栏位异常");
          this.modifyCheckStatus = false
        })
    },
    readyaxiso () {
      if (!this.$route.name.includes('code')) return
      this.chgbacofun();
    },
    go_live_show_bridge () {
      this.$emit("refresh");
    },
    async getMarkList () {
      try {
        this.checkBoxValue = Array.from({length:49}, v => false)
        const res = await this.$axios.liveshow.analyze()
        res[0].marklist.split(',').forEach(it => {
          this.upTargetData(it)
          this.checkBoxValue[Number(it)-1] = true
        })
      } catch (error) {
        console.error(error)
      }
    },
    checkBoxChange(status, item) {
      if (this.getliveshow.targetModeValue) return
      
      if (this.getliveshow.targetData.includes(item.troddid)) this.deleteTargetData(item.troddid)
      else this.upTargetData(item.troddid)

      this.upTargetModeValue(true)
    },
    showStar(item) {
      return this.$route.meta.page == 1 && item.odddtl == 1 && this.checkBoxValue[item.troddid-1]
    },
  }
};
</script>
<style lang="scss">
.rigth-table {
  top: -24px;
}
</style>